import {
  AddButton,
  HeaderSection,
  StatsSection,
  ButtonSection,
  StatItem,
  StatValue,
  StatLabel,
  VerticalDivider,
  flexAlignCenterGap,
  PrimaryButton,
} from '../../../utils/common/styles/commonStyles';
import { Box, TextField, InputAdornment } from '@mui/material';
import { selectAllCollections } from '../store/collection.selectors';
import { useTheme } from '@mui/material/styles';
import TotalIcon from '@mui/icons-material/Dashboard';
import SearchIcon from '@mui/icons-material/Search';
import Add from '@mui/icons-material/Add';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AddCollectionModal from './AddCollection';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { resetCollection } from '../store/collection.actions';
import PropTypes from 'prop-types';

const SearchHeader = (props) => {
  const { searchTerm, setSearchTerm, handleOpenModal } = props;
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const collections = useSelector(selectAllCollections);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const totalCollections = collections?.length || 0;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    dispatch(resetCollection());
    setIsModalOpen(false);
  };
  return (
    <HeaderSection
      sx={{
        padding: '10px',
      }}
    >
      <Box sx={{ ...flexAlignCenterGap(2), flex: 1 }}>
        <TextField
          placeholder="Search collections..."
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            },
          }}
          sx={{
            minWidth: 250,
            backgroundColor: 'background.paper',
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
              transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              '&:hover': {
                boxShadow: '0 4px 16px rgba(102, 126, 234, 0.15)',
                borderColor: '#667eea',
              },
              '&.Mui-focused': {
                boxShadow:
                  '0 0 0 4px rgba(102, 126, 234, 0.15), 0 4px 16px rgba(102, 126, 234, 0.25)',
              },
            },
            '& .MuiInputBase-input::placeholder': {
              opacity: 0.6,
            },
          }}
        />
      </Box>

      <StatsSection
        sx={{
          ...flexAlignCenterGap(3),
          transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
        }}
      >
        {/* Total Collections */}
        <StatItem sx={{ padding: '12px 16px' }}>
          <TotalIcon sx={{ fontSize: 20, color: '#667eea', transition: '0.3s' }} />
          <Box display="flex" alignItems="baseline">
            <StatValue sx={{ color: 'primary.alt', transition: '0.3s' }}>
              {totalCollections}
            </StatValue>
            <StatLabel>Collection</StatLabel>
          </Box>
        </StatItem>

        <PrimaryButton
          variant="contained"
          onClick={() => {
            navigate('/drives?viewAll=true');
          }}
          sx={{ borderRadius: '10px' }}
        >
          View All Drives
        </PrimaryButton>
      </StatsSection>

      <VerticalDivider orientation="vertical" flexItem sx={{ margin: '0 16px' }} />

      <ButtonSection>
        <AddButton
          variant="contained"
          onClick={handleOpenModal}
          startIcon={<Add />}
          fullWidth={isSmallScreen}
        >
          {isSmallScreen ? 'Add' : 'Add Collection'}
        </AddButton>
      </ButtonSection>
      <AddCollectionModal open={isModalOpen} handleClose={handleCloseModal} />
    </HeaderSection>
  );
};
export default SearchHeader;

SearchHeader.propTypes = {
  searchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func,
  handleOpenModal: PropTypes.func,
};
